// The BOT Store catalogue from MBTSDB (REACT_APP_STORE_FROM_DB_ENABLED, default
// on). /api/store sends every visible bot with its zone and category. Zone A keeps
// its existing presentation (names, icons, descriptions, prices, categories in
// App.js) and only shows services the database also lists; Zones B and C are
// built entirely from the database.
export const STORE_FROM_DB_ENABLED = process.env.REACT_APP_STORE_FROM_DB_ENABLED !== "false";

// bots: [{ name, key, description, price, zone, category }]
// -> { A: { keys: Set }, B: { categories: [..], bots: [..] }, C: { ... } }
export function buildStoreCatalog(bots = []) {
  const catalog = { A: { keys: new Set() }, B: { categories: [], bots: [] }, C: { categories: [], bots: [] } };
  for (const bot of Array.isArray(bots) ? bots : []) {
    if (!bot || !bot.key) continue;
    if (bot.zone === "A") { catalog.A.keys.add(bot.key); continue; }
    const zone = catalog[bot.zone];
    if (!zone) continue;
    zone.bots.push(bot);
    if (bot.category && !zone.categories.includes(bot.category)) zone.categories.push(bot.category);
  }
  for (const z of ["B", "C"]) catalog[z].categories.sort((a, b) => a.localeCompare(b));
  return catalog;
}

export async function loadStoreCatalog() {
  try {
    const res = await fetch("/api/store");
    if (!res.ok) return null;
    const data = await res.json();
    return Array.isArray(data?.bots) ? buildStoreCatalog(data.bots) : null;
  } catch (_) {
    return null;
  }
}

export const botsInCategory = (catalog, zone, category) =>
  (catalog?.[zone]?.bots || []).filter((b) => b.category === category);

export const catalogBot = (catalog, key) =>
  ["B", "C"].map((z) => (catalog?.[z]?.bots || []).find((b) => b.key === key)).find(Boolean) || null;
